import NoteService from "../../services/NoteService";

const noteService = new NoteService();

const state = {
    notes: {
        items: [],
        total: 0,
        last_page: 1,
    },
    currentNote: null,
};

const getters = {
    notes: state => state.notes,
};

const actions = {
    async fetchNotes({commit}, params) {
        const {data} = await noteService.fetchNotes(params.patientId, params.query);

        commit('setNotes', {
            items: data.data,
            total: data.total,
            last_page: data.last_page,
        });
    },
};

const mutations = {
    setNotes: (state, notes) => (state.notes = notes),
};

export default {
    state,
    getters,
    actions,
    mutations
};
